import { Grid } from '@mui/material';

import { FiltersBlock } from './FiltersBlock';
import { icons } from './Icons';

interface FilterOption<T> {
  label: string;
  value: T;
}

interface HandoverSectionProps {
  activeQuarter?: string;
  activeYears: string[];
  disabled: boolean;
  handoverOptions: {
    quarters: FilterOption<string>[];
    years: FilterOption<string>[];
  }[];
  onHandoverChange: (value: string, name?: string) => void;
  onPostHandoverChange: (value: boolean, name?: string) => void;
  postHandover?: boolean;
  postHandoverOptions: FilterOption<boolean>[];
  visible: boolean;
}

export const HandoverSection = ({
  activeQuarter,
  activeYears,
  disabled,
  handoverOptions,
  onHandoverChange,
  onPostHandoverChange,
  postHandover,
  postHandoverOptions,
  visible,
}: HandoverSectionProps) => {
  if (!visible) return null;

  return (
    <>
      <Grid item xs={12}>
        <FiltersBlock
          icon={<icons.Handover />}
          name='postHandover'
          type='button'
          size='small'
          title='Post handover'
          options={postHandoverOptions}
          activeButton={postHandover}
          onClick={onPostHandoverChange}
          dataQa='post_handover'
        />
      </Grid>
      <Grid item xs={12} sm={9} lg={9} md={9}>
        <FiltersBlock
          icon={<icons.Handover />}
          name='handover'
          type='doubleButton'
          size='circle'
          title='Handover'
          subTitle={['Quarters', 'Years']}
          options={handoverOptions}
          activeButton={activeQuarter}
          activeButtonYears={activeYears}
          onClick={onHandoverChange}
          dataQa='handover'
          disabled={disabled}
        />
      </Grid>
    </>
  );
};
